// Force a real file download inside the app instead of letting the browser
// navigate away / open a new tab. Falls back to opening in a new tab only
// when the blob fetch fails (e.g. cross-origin without CORS headers).
export const downloadFile = async (url, name) => {
  try {
    const res = await fetch(url, { credentials: 'include' });
    if (!res.ok) throw new Error(`Download failed (${res.status})`);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = name || decodeURIComponent(url.split('/').pop().split('?')[0]) || 'file';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 10000);
  } catch (e) {
    window.open(url, '_blank');
  }
};

export default downloadFile;
